import { useAppDispatch } from "app/store";
import { doc, serverTimestamp, setDoc, updateDoc } from "firebase/firestore";
import { FirebaseRefs, GetStartedStoreTypes } from "interfaces";
import { getStartedActions } from "pages/GetStarted/getStartedSlice";
import { selectUserProfile } from "pages/User";
import { useSelector } from "react-redux";
import { db } from "utils";

export function useGetStarted() {
  const user = useSelector(selectUserProfile);
  const dispatch = useAppDispatch();

  const save = async ({
    data,
    currentStep,
    docExists,
    setHasInitDetDoc
  }: {
    data: GetStartedStoreTypes;
    currentStep: number;
    docExists: boolean;
    setHasInitDetDoc: React.Dispatch<React.SetStateAction<boolean>>;
  }) => {
    if (!user?.uid && !docExists) {
      dispatch(
        getStartedActions.setInitialDetails({
          data,
          step: currentStep
        })
      );
    } else if (user?.uid && !docExists) {
      await setDoc(doc(db, FirebaseRefs.INITIAL_DETAILS, user.uid), {
        data,
        step: currentStep,
        uid: user.uid,
        isCompleted: false,
        createdAt: serverTimestamp()
      });
      setHasInitDetDoc(true);
      dispatch(
        getStartedActions.setInitialDetails({
          data,
          step: currentStep
        })
      );
    } else if (user?.uid && docExists) {
      const userRef = doc(db, FirebaseRefs.INITIAL_DETAILS, user.uid);

      await updateDoc(userRef, {
        data,
        step: currentStep,
        updatedAt: serverTimestamp()
      });

      dispatch(
        getStartedActions.setInitialDetails({
          data,
          step: currentStep
        })
      );
    }
  };

  const finish = (data: GetStartedStoreTypes) => {
    dispatch(
      getStartedActions.setInitialDetails({
        data,
        step: 3,
        isCompleted: true
      })
    );
  };

  const onEndChat = async (cb: VoidFunction) => {
    if (user?.uid) {
      const userRef = doc(db, FirebaseRefs.INITIAL_DETAILS, user.uid);

      await updateDoc(userRef, {
        chatEnded: true
      });

      cb();
    }
  };

  const fullServiceRequired = (store: {
    finance: {
      business_trust: string;
      other_trust: string;
      property_consent_lodged: string;
      joint_assets_1_5m_exceed: string;
    };
  }) =>
    store?.finance?.business_trust === "yes" ||
    store?.finance?.other_trust === "yes" ||
    store?.finance?.property_consent_lodged === "yes" ||
    store?.finance?.joint_assets_1_5m_exceed === "yes"
      ? true
      : false;

  const outOfTime = (store: {
    relationship: {
      relationship: string;
      separated_2y: string;
      divorced_1y: string;
    };
  }) =>
    (store?.relationship?.relationship === "defacto" && store?.relationship?.separated_2y === "yes") ||
    (store?.relationship?.relationship === "married" && store?.relationship?.divorced_1y === "yes")
      ? true
      : false;

  return { save, finish, fullServiceRequired, outOfTime, onEndChat };
}
